import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalString,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createInvoicesAddSchema = () =>
    z.object({
        id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        contact_id: requiredUuid(),
        deep_link: optionalString(),
        external_id: optionalString(),
        number: optionalString(),
        status: optionalString(),
        sub_total: optionalString(),
        total_tax: optionalString(),
        total: optionalString(),
        total_discount: optionalString(),
        sent_to_contact: optionalBoolean(),
        authorised_time: optionalString(),
        sent_to_contact_time: optionalString(),
        payment_date_time: optionalString(),
        due_date_time: requiredString(),
        reference: requiredString(),
        attach_reports: optionalBoolean(),
        public_url: optionalString(),
        synced: optionalBoolean(),
        invoice_date: optionalString(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        apply_taxes: optionalBoolean(),
        amount_check: requiredString(),
        footer_text: optionalString(),
        amount_valid: optionalBoolean(),
        last_synced_at: optionalString(),
        tax_rate: optionalString(),
        products_tax_rate: optionalString(),
        provider: requiredString(),
        user_provider_email: optionalString(),
        provider_archived_at: optionalString(),
    });

export const createInvoicesUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createInvoicesAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.invoices,
    );

export const createInvoicesDeleteSchema = () => createDeleteSchema();

export const createInvoicesSchemas = () => ({
    add: createInvoicesAddSchema(),
    update: createInvoicesUpdateSchema(),
    delete: createInvoicesDeleteSchema(),
});
